export default {
    _asapbold: 'asapbold',
}